<template>
  <form-card :label-text="$t('api.branch.fields.marketplace_block.label')">
    <el-row :gutter="10" class="sales-time" v-if="value.length == 0">
      <el-col :xs="4" :md="5" class="sales-time-button">
        <form-item
          name="action"
          :hasLabel="true"
          :label="$t('api.branch.fields.branch_block.label')"
          :hasDesc="true"
          :descContent="$t('api.branch.fields.branch_block.desc')"
          >
          <el-button
            type="primary"
            icon="el-icon-plus"
            circle
            @click="addRow(0)"
            >
          </el-button>
        </form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="sales-time" v-else
      v-for="(b, idx) in value"
      :key="idx"
      >
      <el-col :xs="4" :md="5" class="sales-time-button">
        <form-item
          name="action"
          :hasLabel="idx <= 0"
          :label="$t('api.branch.fields.branch_block.label')"
          :hasDesc="idx <= 0"
          :descContent="$t('api.branch.fields.branch_block.desc')"
          >
          <el-button
            type="primary"
            icon="el-icon-plus"
            circle
            @click="addRow(idx)"
            >
          </el-button>
          <el-button
            v-if="value.length >= 1"
            type="danger"
            icon="el-icon-minus"
            circle
            @click="minusRow(idx)"
            >
          </el-button>
        </form-item>
      </el-col>
      <el-col :xs="8" :md="6">
        <remote-opt
          v-model="b.uid"
          name="branch_block.user_uid"
          base="branch"
          keyName="uid"
          valueName="uid"
          sort="uid"
          :prop="getBlockPropPath(idx, 'uid')"
          :required="true"
          :labelArr="['uid', 'unhide_uid', 'email']"
          :fetchList="fetchUserMemberList"
          :srchFilter="getUserMemberListFilter()"
          :hasLabel="idx <= 0"
          @change="updateBlocks"
          :isAutoFetch="false"
          >
        </remote-opt>
      </el-col>
      <el-col :xs="8" :md="13">
        <text-field
          v-model="b.remark"
          base="branch"
          name="branch_block.remark"
          :prop="getBlockPropPath(idx, 'remark')"
          :required="true"
          :hasLabel="idx <= 0"
          @change="updateBlocks"
          >
        </text-field>
      </el-col>
    </el-row>
  </form-card>
</template>

<script>

import { fetchList as fetchUserList } from '@/api/user/user'

const defBlock = {
  id: 0,
  uid: undefined,
  remark: ''
}

export default {
  name: 'branch-block',
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    updateBlocks () {
      this.$emit('input', this.value)
    },
    addRow (idx) {
      this.value.push(Object.assign({}, defBlock))
      this.updateBlocks()
    },
    minusRow (idx) {
      this.$emit('delBlock', this.value[idx])
      this.value.splice(idx, 1)
      this.updateBlocks()
    },
    fetchUserMemberList (query) {
      return fetchUserList(query, 'member')
    },
    getUserMemberListFilter () {
      return '{$or:[{uid:`int`},{unhide_uid:`int`}]}'
    },
    getBlockPropPath (idx, name) {
      // in order to validate a property which is a member in array from formData
      // for example: `block.0.remark` means formData.block[0].remark
      return `block.${idx}.${name}`
    }
  }
}
</script>
